const PHPURL = {
    'baseURL': 'https://admin.crucearosie6.ro/',

    'autoLogin': 'php/autoLogin.php',

    'login': 'php/login.php',

    'insertData': 'php/insertData.php',

    'updateData': 'php/updateData.php',

    'deleteData': 'php/deleteData.php',

    'getData': 'php/getData.php?table=',

    'getSpecialUsersList': 'php/getSpecialUsersList.php',
    
    'getActivitiesList': 'php/getActivitiesList.php?',

    'getActivitiesForVolunteer': 'php/getActivitiesForVolunteer.php?volunteer=',

    'getVolunteersAtActivity': 'php/getVolunteersAtActivity.php?id=',

    'getVolunteersAtCourse': 'php/getVolunteersAtCourse.php?id=',

    'getOptions': 'php/getOptions.php',

    'getDomains': 'php/getDomains.php',

    'getTypes': 'php/getTypes.php',

    'getActivitiesInDomain': 'php/getActivitiesInDomain.php?domain=',

    'getCertificateData': 'php/getCertificateData.php?contract=',

    'insertVolunteerAtActivity': 'php/insertVolunteerAtActivity.php',

    'reportsDataGathering': 'php/reportsDataGathering.php'

}

export default PHPURL;


// WEBPACK FOOTER //
// ./src/reducers/ReducerPHPURL.js